import {createFileRoute} from '@tanstack/react-router';
import {viewDiagnosticReportGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import EncounterDetail from '@/practitioner/views/encounter/EncounterDetail';

export const Route = createFileRoute('/(practitioner)/patients/$patientId/encounters/$encounterId')(
  {
    component: EncounterDetail,
    beforeLoad: grantUser(viewDiagnosticReportGranted),
    loader: ({params}) => ({
      patientId: params.patientId,
      encounterId: params.encounterId
    })
  }
);
